
import normalize from 'json-api-normalizer';

import Resource from './resource';

export default class Page {
	static from (jsonapi) {
		let normalizedJSONapi = normalize(jsonapi);
		if (Object.keys(normalizedJSONapi).length == 0) return null;
		let key = Object.keys(normalizedJSONapi)[0]  // Pages come in many types

		let keys = Object.keys(normalizedJSONapi[key]);
		if (keys.length > 0 && Array.isArray(jsonapi.data)) {
			let retVal = {};
			keys.forEach( function ( id ) {
				retVal[id] = Page.make(normalizedJSONapi[key][id], normalizedJSONapi);
			});
			return retVal;
		} else return Page.make(normalizedJSONapi[key][keys[0]], normalizedJSONapi);
	}

	static make(jsonapi, normalizedJSONapi, noRelationships=0) {
		const { id, type, attributes } = jsonapi;
		let pagetype = attributes['pageType'] ? attributes['pageType'] : type
		delete attributes['pageType']

		let relationships = {}
		if (jsonapi.relationships && jsonapi.relationships['pages']) {
			relationships['pages'] = []
			jsonapi.relationships['pages'].data.forEach( function (rel) {
				relationships['pages'].push(rel);
			});
		}

		if (jsonapi.relationships && jsonapi.relationships['resources'] && normalizedJSONapi['resources'] && noRelationships == 0) {
			relationships['resources'] = {};
			jsonapi.relationships['resources'].data.forEach( function (rel) {
				relationships['resources'][rel.id] = Resource.make(normalizedJSONapi[rel.type][rel.id], normalizedJSONapi);
			});
		}

		return new Page ( Object.assign({id: id, type: pagetype}, attributes, relationships) );
	}

	constructor ({ id, type, title, position, body, bodyText, textToSpeech, internalName, state, parentId, pages, path, resources, viewed }) {
		this.image_changed = null;
		this.id            = id ? id : -1;
		this.title         = title ? title : '';
		this.internal_name = internalName ? internalName : '';
		this.position      = position ? position : 0;
		this.body          = body ? body.replace(/##HIPPO_URL##/g, process.env.VUE_APP_API_URL) : '';
		this.body_text     = bodyText ? bodyText.replace(/##HIPPO_URL##/g, process.env.VUE_APP_API_URL) : '';
		this.text_to_speech	= textToSpeech ? textToSpeech : false;
		this.type          = type ? type : 'pages';
		this.parent_id     = parentId ? parentId : null;
		this.state         = state ? state : 'draft'
		this.pages         = pages ? pages : [];
		this.path          = path ? path : '/' + this.id;
		this.resources     = resources ? resources : {};
		this.viewed		   = viewed ? viewed : false;
	}

	displayName() {
		return this.first_name + ((this.last_name.length > 0) ? ( ' ' + this.last_name.substr(0, 1) + '.' ) : '');
	}

	toJSONapi () {
		let attributes = Object.assign({}, this);
		delete attributes.id;
		delete attributes.type;
		delete attributes.path;
		delete attributes.resources;

		let hippo_regex = new RegExp(process.env.VUE_APP_API_URL.replace(/\//g, '\\\/'), "g");
		attributes.body = attributes.body.replace(hippo_regex, '##HIPPO_URL##');

		if (attributes.image_changed == null) delete attributes.image_changed;

		return {data: {type: this.type, id: this.id, attributes: attributes}};
	}
}
